import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

import { SimpleDate } from '@app/core/models';
import { RegionService, DateService } from '@app/core/services';

@Pipe({
  name: 'ingoDate'
})
export class IngoDatePipe implements PipeTransform {

  private dateFormats = {
    SE: 'yyyy.MM.dd',
    DK: 'dd.MM.yyyy'
  };

  constructor(
    private datePipe: DatePipe,
    private regionService: RegionService,
    private dateService: DateService
  ) {}

  transform(value: any, withTime: boolean = false): string {
    const countryCode = this.regionService.getCountryCode();
    if (this.isSimpleDate(value)) {
      value = this.dateService.simpleDateToDate(value);
    }
    let format = this.dateFormats[countryCode];
    if (withTime) {
      format = `${format} H:mm`;
    }
    return this.datePipe.transform(value, format);
  }

  private isSimpleDate(value: any): boolean {
    return (
      typeof value !== 'object' ||
      value instanceof Date ||
      !value.hasOwnProperty('year')
    ) ? false : true;
  }
}
